
import axios from 'axios'; //引用axios
import { Message } from 'element-ui';
import $store from '@/store/index.js'; //使用Vuex
const Axios = axios.create({
  baseURL: process.env.NODE_ENV == 'development' ? '/api' : '/api', // 接口地址
});

// 请求拦截
Axios.interceptors.request.use(
  (config) => {
    //获取 token
    const token = $store.state.token;
    if (token) {
      // 在请求头上带上 token，固定写法
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// 响应拦截
Axios.interceptors.response.use(
  (res) => {
    let result = null;
    const code = res.data.code; //服务器端返回的状态码
    $store.commit('SET_MESSAGE', res.data.msg);
    if (res.data?.data?.token) {
      //将服务器返回的最新token更新到本地中
      $store.commit('SET_TOKEN', res.data.data.token); // 将服务器返回的最新token更新到本地中
    }
    if (code == 200) {
      //响应成功
      result = res.data.data;
      if (!res.data.data) result = [];
    } else {
      switch (code) {
        case 300: //未登录或登录超时，请先登录,操作逻辑清除 token 和用户信息
          $store.commit('clearToken');
          $store.commit('clearUserInfo');
          break;
      }

      //失败的情况下 提示
      Message({
        message: res.data.message || res.data.msg,
        type: 'error',
      });
    }
    return result;
  },
  (err) => {
    console.error(err, err.response.status);
    Message({
      message: '服务器报错了：' + err, // 此处可以换成接口返回的报错信息
      type: 'error',
    });
    return Promise.reject(err);
  }
);

export default Axios;
